import { render, staticRenderFns } from "./headlinesConfig.vue?vue&type=template&id=0538aa28&scoped=true"
import script from "./headlinesConfig.vue?vue&type=script&lang=js"
export * from "./headlinesConfig.vue?vue&type=script&lang=js"
import style0 from "./headlinesConfig.vue?vue&type=style&index=0&id=0538aa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0538aa28",
  null
  
)

export default component.exports